export default "__VITE_ASSET__D4ljwtk0__"